import api from "./api";

export const getTypicalCustomers = async () => {
    try {
        const response = await api.get("/api/typical-customers");
        const data = response.data;
        return Array.isArray(data) ? data : (data?.content || data?.items || data?.data || []);
    } catch (error) {
        throw error;
    }
};
